import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthChildrenGuardGuard implements CanActivate {

  constructor(private router: Router,
    private storageService: StorageService) { }

    canActivate() {
      //console.log(this.storageService.isAuthenticated());
      let loginUserData = this.storageService.getCurrentUser();
      if (this.storageService.isAuthenticated() && loginUserData.strRolName==="Cliente") {
        // logged in so return true
        return true;
      }
      this.storageService.logout();
      //this.router.navigate(['/login']);
      return false;
    }
}
